import { Component, OnInit } from '@angular/core';
import { selectCurrentLanguage, TranslateActions } from '../../store';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

@Component({
  selector: 'payment-language-dropdown-container',
  templateUrl: './language-dropdown-container.component.html',
  styleUrls: ['./language-dropdown-container.component.scss'],
})
export class LanguageDropdownContainerComponent implements OnInit {
  currentLanguage$: Observable<string>;

  constructor(private store: Store) {}

  ngOnInit(): void {
    this.currentLanguage$ = this.store.select(selectCurrentLanguage);
  }

  onLanguageSelected(event: string) {
    this.store.dispatch(
      TranslateActions.languageSelectedFromDropdown({
        language: event,
      }),
    );
  }
}
